import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getStoreStatisticsStart,
  getStoreStatisticsSuccess,
  getStoreStatisticsFailed,
  getSMBannersStart,
  getSMBannersSuccess,
  getSMBannersFailed,
  createSMBannerStart,
  createSMBannerSuccess,
  createSMBannerFailed,
  updateSMBannerStart,
  updateSMBannerSuccess,
  updateSMBannerFailed,
  deleteSMBannerStart,
  deleteSMBannerSuccess,
  deleteSMBannerFailed,
  sendRequestInformationEmailStart,
  sendRequestInformationEmailSuccess,
  sendRequestInformationEmailFailed,
  getFutureAssignedTasksStart,
  getFutureAssignedTasksSuccess,
  getFutureAssignedTasksFailed,
} from 'redux/actions/home';


export const getStoreStatisticsApi = async ({dispatch}) => {
  try {
    dispatch(getStoreStatisticsStart());
    const {data} = await api.get(`${shopManagerApi}/store/statistics/base`);
    dispatch(getStoreStatisticsSuccess(data));
  } catch (e) {
    dispatch(getStoreStatisticsFailed(e));
  }
};

export const getSMBannersAPI = async ({dispatch}) => {
  try {
    dispatch(getSMBannersStart());
    const {data} = await api.get(`${shopManagerApi}/shopmanager/banners`);
    dispatch(getSMBannersSuccess(data));
  } catch (e) {
    dispatch(getSMBannersFailed(e));
  }
};

export const createSMBannerAPI = async ({dispatch, formData}) => {
  try {
    dispatch(createSMBannerStart());
    const { data } = await api.post(`${shopManagerApi}/shopmanager/banners`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(createSMBannerSuccess(data));
  } catch (e) {
    dispatch(createSMBannerFailed(e));
  }
};

export const updateSMBannerAPI = async ({dispatch, formData, id}) => {
  try {
    dispatch(updateSMBannerStart());
    const {data} = await api.patch(`${shopManagerApi}/shopmanager/banners/${id}`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(updateSMBannerSuccess(data));
  } catch (e) {
    dispatch(updateSMBannerFailed(e));
  }
};

export const deleteSMBannerAPI = async ({dispatch, id}) => {
  try {
    dispatch(deleteSMBannerStart());
    const {data} = await api.delete(`${shopManagerApi}/shopmanager/banners/${id}`);
    dispatch(deleteSMBannerSuccess(id, data));
  } catch (e) {
    dispatch(deleteSMBannerFailed(e));
  }
};

export const sendRequestInformationEmailAPI = async ({dispatch, message}) => {
  try {
    dispatch(sendRequestInformationEmailStart());
    const {data} = await api.post(`${shopManagerApi}/shopmanager/request-information`, { message });
    dispatch(sendRequestInformationEmailSuccess(data));
    return true;
  } catch (e) {
    dispatch(sendRequestInformationEmailFailed(e));
    return false;
  }
};

export const getFutureAssignedTasks = async ({dispatch}) => {
  try {
    dispatch(getFutureAssignedTasksStart());
    const { data } = await api.get(`${shopManagerApi}/deal/task-assigned`);
    dispatch(getFutureAssignedTasksSuccess(data));
  } catch (e) {
    dispatch(getFutureAssignedTasksFailed(e));
  }
};
